import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-investments',
  templateUrl: './new-investments.component.html',
  styleUrls: ['./new-investments.component.scss']
})
export class NewInvestmentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
